import React, { createContext, FunctionComponent, ReactNode, useContext } from 'react';

const ScopeContext = createContext('main');

export interface ScopeProps {
  scope: string;
  children: ReactNode;
}

/**
 * Sets the scope for any descendant components. Scopes are used to enable multiple independent database
 * drafts for the same database (for example when a dialog is editing parts of a database draft).
 */
const Scope: FunctionComponent<ScopeProps> = ({ scope, children }) => (
  <ScopeContext.Provider value={scope}>{children}</ScopeContext.Provider>
);

export default Scope;

export function useScope(): string {
  return useContext(ScopeContext);
}
